import type { Language, Recipe } from "../data";

export function getIngredientName(ing: { nameAr: string; nameEn: string; [key: string]: unknown }, lang: Language): string {
  const map: Record<Language, string> = {
    ar: "nameAr", en: "nameEn",
  };
  return (ing as Record<string, string>)[map[lang]];
}

export function getRecipeName(r: Recipe, lang: Language): string {
  const map: Record<Language, keyof Recipe> = {
    ar: "nameAr", en: "nameEn",
  };
  return r[map[lang]] as string;
}

export function getRecipeSteps(r: Recipe, lang: Language): string[] {
  if (lang === "ar") return r.stepsAr;
  return r.stepsEn;
}

export function getOvenTemp(r: Recipe, lang: Language): string | undefined {
  return lang === "ar" ? r.ovenTempAr : r.ovenTempEn;
}

export function getCookingTips(r: Recipe, lang: Language): string[] {
  return lang === "ar" ? (r.tipsAr ?? []) : (r.tipsEn ?? []);
}

export function getServingTips(r: Recipe, lang: Language): string[] {
  return lang === "ar" ? (r.servingAr ?? []) : (r.servingEn ?? []);
}

export function scaleAmount(amount: number | null, baseServings: number, currentServings: number): string | null {
  if (amount === null) return null;
  const scaled = (amount * currentServings) / baseServings;
  if (scaled >= 100) return Math.round(scaled).toString();
  if (scaled >= 10) return (Math.round(scaled * 2) / 2).toString();
  return (Math.round(scaled * 10) / 10).toString();
}

const FOOD_PLACEHOLDER = "images/recipes/pexels-1640777-600.jpeg";

export function getFoodImage(_dishName: string, _cuisine: string): string {
  return FOOD_PLACEHOLDER;
}

